import { ActionType, createAction } from 'typesafe-actions'
import { ChatState } from '../../types'
import { DTO } from './types'
import { updateChatInChatsState } from '../helpers'

export const updateArchiveChatAction = createAction('@chat/UPDATE_ARCHIVE_CHAT')<DTO>()

const success = (state: ChatState, action: ActionType<typeof updateArchiveChatAction>): ChatState => ({
  ...state,
  archiveChats: updateChatInChatsState(action.payload, state.archiveChats)
})

export const updateArchiveChatHandle = { asyncAction: updateArchiveChatAction, success }
